// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TT99","label":"styles_label__3gqjl"};